(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inaklam-bildvergleich"] && !Shopify.designMode) return;
  try {
    function initInaklamComparison(scope){
 scope.querySelectorAll('[data-ibg-compare]').forEach(root=>{
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const slider=root.querySelector('input[type="range"]');
  slider.disabled=false;
  const update=()=>{root.style.setProperty('--split',slider.value+'%');slider.setAttribute('aria-valuetext',slider.value+' Prozent Zeichnung sichtbar');};
  slider.addEventListener('input',update);
  update();
 });
}
initInaklamComparison(document);
document.addEventListener('shopify:section:load',event=>initInaklamComparison(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inaklam-cart-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inaklam-gift-wrap')) {
    customElements.define('inaklam-gift-wrap', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', async (event) => {
          event.stopPropagation();
          const select = event.target;
          if (select.tagName !== 'SELECT' || this.busy) return;
          this.busy = true;
          select.disabled = true;
          const status = this.querySelector('[role="status"]');
          status.textContent = '';
          const drawer = this.closest('cart-drawer');
          const quantity = Number(select.value);
          const body = this.dataset.key ? { id: this.dataset.key, quantity } : { items: [{ id: Number(this.dataset.variant), quantity }] };
          if (drawer) {
            body.sections = drawer.getSectionsToRender().map(section => section.id);
            body.sections_url = location.pathname;
          }
          try {
            const note = document.querySelector(drawer ? '#CartDrawer-Note' : '#Cart-note');
            if (note) {
              const saved = await fetch(window.routes.cart_update_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: note.value }) });
              if (!saved.ok) throw new Error('note');
            }
            const response = await fetch((this.dataset.key ? window.routes.cart_change_url : window.routes.cart_add_url) + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
            const result = await response.json();
            if (!response.ok || result.errors || result.status) throw new Error('cart');
            if (drawer && result.sections && result.sections['cart-drawer']) {
              drawer.renderContents(result);
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'inaklam-gift-wrap' });
            } else location.reload();
          } catch (error) {
            status.textContent = this.dataset.error;
            select.value = select.querySelector('[selected]')?.value || '0';
          } finally {
            this.busy = false;
            select.disabled = false;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inaklam-warranty-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inaklam-warranty')) {
    customElements.define('inaklam-warranty', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || typeof HTMLDialogElement === 'undefined') return;
        this.ready = true;
        this.trigger = this.querySelector('summary');
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.openNotice();
        });
      }
      openNotice() {
        if (this.dialog) return;
        const dialog = document.createElement('dialog');
        dialog.className = 'inaklam-warranty-dialog';
        dialog.setAttribute('aria-label', this.trigger.querySelector('span').textContent);
        dialog.append(this.querySelector('.inaklam-warranty-content').cloneNode(true));
        this.dialog = dialog;
        const drawer = this.closest('cart-drawer');
        const wasLocked = document.body.classList.contains('overflow-hidden');
        if (drawer && typeof removeTrapFocus === 'function') removeTrapFocus();
        document.body.classList.add('overflow-hidden');
        document.body.append(dialog);
        dialog.querySelector('.inaklam-warranty-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.querySelector('.inaklam-warranty-zoom').addEventListener('click', (event) => {
          const button = event.currentTarget;
          const zoomed = dialog.querySelector('.inaklam-warranty-image-area').classList.toggle('is-zoomed');
          button.setAttribute('aria-pressed', String(zoomed));
          button.textContent = zoomed ? button.dataset.fit : button.dataset.zoom;
        });
        dialog.addEventListener('close', () => {
          dialog.remove();
          this.dialog = null;
          if (!wasLocked) document.body.classList.remove('overflow-hidden');
          if (this.isConnected) {
            if (drawer && drawer.classList.contains('active') && typeof trapFocus === 'function') {
              trapFocus(drawer.querySelector('.drawer__inner'), this.trigger);
            } else this.trigger.focus({preventScroll: true});
          }
        }, {once: true});
        dialog.showModal();
        dialog.querySelector('.inaklam-warranty-close').focus({preventScroll: true});
      }
      disconnectedCallback() {
        if (this.dialog) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
